import { Component, HostListener, signal } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { ToastService } from '@app/core/services/toast.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsersService } from 'api-v3/services';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-mail-verification-dialog',
    templateUrl: './mail-verification-dialog.component.html',
    styleUrls: ['./mail-verification-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class MailVerificationDialogComponent {
    wrongCodeError = signal(false);
    showSuccess = signal(false);

    oneTimeCodesForm = new UntypedFormGroup({
        oldMailCode: new UntypedFormControl('', [Validators.required]),
        newMailCode: new UntypedFormControl('', [Validators.required]),
    });

    constructor(
        private usersService: UsersService,
        private sessionService: SessionService,
        private toastr: ToastService,
        private translateService: TranslateService
    ) {}

    @HostListener('window:keydown.enter')
    async completeEmailChange() {
        if (this.oneTimeCodesForm.invalid) {
            this.oneTimeCodesForm.markAllAsTouched();
            return;
        }

        const oldMailCode = this.oneTimeCodesForm.value['oldMailCode'].trim();
        const newMailCode = this.oneTimeCodesForm.value['newMailCode'].trim();

        try {
            await lastValueFrom(
                this.usersService.verifyEmailChangeV3({
                    body: {
                        codeOld: oldMailCode,
                        codeNew: newMailCode,
                    },
                })
            );
            this.toastr.success(
                this.translateService.instant('VERIFY-MAIL-DIALOG.SUCCESS')
            );
            this.sessionService.logout();
        } catch (e) {
            this.wrongCodeError.set(true);
        }
    }
}
